var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5244 4.52628C14.2971 3.38419 13.7206 2.34081 12.8746 1.54017C12.0286 0.739533 10.9548 0.221118 9.80139 0.0564903C8.64802 -0.108137 7.47196 0.0891406 6.43555 0.621092C5.39915 1.15304 4.55351 1.99344 4.01537 3.02626C2.8702 3.15079 1.81635 3.70929 1.07066 4.58684C0.324976 5.4644 -0.0558225 6.59424 0.00662645 7.74389C0.0690754 8.89354 0.570021 9.97554 1.40638 10.7672C2.24274 11.5589 3.3509 12.0001 4.50282 12H14.2579C15.2274 11.9996 16.159 11.6233 16.8565 10.9503C17.554 10.2773 17.9631 9.36003 17.9976 8.39163C18.0322 7.42322 17.6895 6.47919 17.0417 5.75824C16.3938 5.03729 15.4915 4.59565 14.5244 4.52628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71094 6.92139L8.34019 8.55042L10.7847 5.29297",
    stroke: "#4D88FF",
    strokeWidth: 1.00495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.aaeed9b834d7bdf2611d91c7957505ae.svg";
export { ForwardRef as ReactComponent };